import { HStack, VStack } from "@gluestack-ui/themed";
import { TransactionInfoSectionProps } from "./types";
import { Icon } from "@repo/core/components/core/Icon";
import { Text } from "@repo/core/components/core/Text";
import { TransactionInfo } from "../../infos/TransactionInfo";
import { numberToBrl } from "@repo/core/utils/currency.utils";
import { getOperationStringByType, getPaymentMethodNameByType } from "./utils";
import { formatDateTimeString } from "@repo/core/utils/date.utils";
import {
  TransactionPaymentMethodEnum,
  typeOfInstallment
} from "@repo/core/constants/transactions";

export const TransactionInfoSection = ({
  title,
  icon = "times",
  dateTime,
  paymentMethod,
  cet,
  value,
  installmentType,
  interestValue,
  totalValue,
  installmentsQuantity,
  installmentValue,
  operation
}: TransactionInfoSectionProps) => {
  return (
    <VStack gap={16} py="$4">
      <HStack alignItems="center" gap={8}>
        <Icon name={icon} size={18} />
        <Text fontWeight={600}>{title}</Text>
      </HStack>

      {dateTime && (
        <TransactionInfo
          name="Data e Hora"
          value={formatDateTimeString(dateTime)}
        />
      )}
      {operation && (
        <TransactionInfo
          name="Operação"
          value={getOperationStringByType(operation)}
        />
      )}
      {(paymentMethod || installmentType) && (
        <TransactionInfo
          name="Forma de Pagamento"
          value={
            paymentMethod == TransactionPaymentMethodEnum.CREDIT
              ? getPaymentMethodNameByType(paymentMethod)
              : installmentType
                ? typeOfInstallment[installmentType]
                : ""
          }
        />
      )}
      {cet && <TransactionInfo name="CET(A.A)" value={`${cet}%`} />}
      {value && <TransactionInfo name="Valor" value={numberToBrl(value)} />}
      {interestValue && (
        <TransactionInfo name="Juros" value={numberToBrl(interestValue)} />
      )}
      {installmentValue && installmentsQuantity && (
        <TransactionInfo
          name="Parcelas"
          value={`${installmentsQuantity}x de ${numberToBrl(installmentValue)}`}
          fontWeight={600}
        />
      )}
      {totalValue && (
        <TransactionInfo
          name="Valor Total"
          value={numberToBrl(totalValue)}
          fontWeight={600}
        />
      )}
    </VStack>
  );
};
